import React from 'react';

const setLabel = (s) => {
  const bom = !s.bom_count ? ' · No combo BOM' : s.bom_count < s.size_count ? ` · BOM ${s.bom_count}/${s.size_count} sizes` : '';
  return `${s.section || 'No section'} · ${s.first_barcode}–${s.last_barcode}${bom}`;
};

export const selectedMrpOption = (r) =>
  (r._barcodeOptions || []).find((o) => r.customer_mrp != null && Number(o.mrp) === Number(r.customer_mrp));

/** Why this row cannot be planned yet (MRP with several barcode sets), else null. */
export const rowSetIssue = (r) => {
  const o = selectedMrpOption(r);
  if (!o || (o.sets || []).length < 2) return null;
  const s = o.sets.find((x) => r.rate_section != null && x.set_key === r.rate_section);
  if (!s) return `pick the barcode set for ₹${o.mrp} (${o.sets.length} sets)`;
  if (!s.bom_count) return `barcode set "${s.section || 'No section'}" has no combo BOM yet — add it in Combo BOM Master`;
  return null;
};

const SetPicker = ({ r, idx, opt, onSelectSet }) => {
  const chosen = opt.sets.find((x) => r.rate_section != null && x.set_key === r.rate_section);
  return (
    <div className="mt-1 space-y-0.5">
      <select
        data-testid={`set-select-${idx}`}
        value={chosen ? `sec:${chosen.set_key}` : ''}
        title={chosen ? setLabel(chosen) : 'Pick the barcode set'}
        onChange={(e) => onSelectSet(idx, e.target.value === '' ? null : e.target.value.slice(4))}
        className={'w-full h-9 rounded-md border px-2 text-xs ' + (chosen ? 'border-stone-300' : 'border-amber-400 bg-amber-50 text-amber-900')}
      >
        <option value="">— pick barcode set ({opt.sets.length}) —</option>
        {opt.sets.map((s) => <option key={s.set_key} value={`sec:${s.set_key}`}>{setLabel(s)}</option>)}
      </select>
      {chosen && (
        <p className="text-[10px] text-stone-500 font-mono leading-tight" data-testid={`set-range-${idx}`}>
          {chosen.first_barcode}–{chosen.last_barcode}
        </p>
      )}
      {chosen && !chosen.bom_count && (
        <p className="text-[10px] text-rose-600 leading-tight" data-testid={`set-no-bom-${idx}`}>
          No combo BOM for this set — add it in Combo BOM Master before planning.
        </p>
      )}
    </div>
  );
};

/** Customer MRP cell of the Combo V2 matrix planners + barcode-set picker when an MRP has several sets. */
export const MrpSetCell = ({ r, idx, onSelectMrp, onSelectSet }) => {
  const opts = r._barcodeOptions || [];
  const opt = selectedMrpOption(r);
  if (opts.length === 0) {
    return (
      <div className="text-xs text-stone-400 italic h-9 flex items-center px-1">
        {r._loadingBarcodes ? 'Loading…' : (r.design_name && r.shade ? 'No MRP in rates_master' : 'Pick design first')}
      </div>
    );
  }
  return (
    <div>
      {opts.length === 1 ? (
        <div className="text-xs h-9 flex flex-col justify-center px-2 rounded-md bg-stone-50 border border-stone-200" data-testid={`mrp-single-${idx}`}>
          <span className="text-stone-800 font-semibold">₹{r.customer_mrp}</span>
          <span className="text-stone-500">{opts[0]?.barcode_count ?? 1} barcode(s) · {opts[0]?.size_count ?? 0} size(s)</span>
        </div>
      ) : (
        <select
          data-testid={`mrp-select-${idx}`}
          value={r.customer_mrp == null ? '' : String(r.customer_mrp)}
          onChange={(e) => onSelectMrp(idx, e.target.value)}
          className={'w-full h-9 rounded-md border px-2 text-sm ' + (r.customer_mrp != null ? 'border-stone-300' : 'border-amber-400 bg-amber-50 text-amber-900')}
        >
          <option value="">— pick MRP —</option>
          {opts.map((o) => <option key={o.mrp} value={String(o.mrp)}>₹{o.mrp}  ·  {o.barcode_count} barcode(s)</option>)}
        </select>
      )}
      {opt && (opt.sets || []).length > 1 && <SetPicker r={r} idx={idx} opt={opt} onSelectSet={onSelectSet} />}
    </div>
  );
};

export default MrpSetCell;
